module.exports = __webpack_public_path__ + "static/media/anxious-face-with-sweat-svgrepo-com.d0b55ebe.svg";